export default {
  title: 'Data Reports',
  salesReport: 'Sales Report',
};
